import { ApiClient } from '../core/api-client.js?v=6.92.8';
import { Permissions } from '../core/permissions.js?v=6.87.12';
import { ScreenRegistry } from '../core/screen-registry.js?v=6.88.0';
import { parseRoute, formatRoute } from '../core/route-state.js?v=6.87.13';
import { ViewStateStore } from '../core/view-state.js?v=6.87.12';
import { ScreenStateStore } from '../core/screen-state.js?v=6.87.12';
import { NoticeCenter } from '../core/notice-center.js?v=6.87.12';
import { MAIN_NAVIGATION, UTILITY_NAVIGATION, ACCOUNT_NAVIGATION, ROUTE_NAVIGATION, canAccessNavigationItem, resolveNavigationTarget } from '../navigation/navigation-manifest.js?v=6.87.12';
import { LoginController } from '../auth/login-controller.js?v=6.88.99';
import { ModalLifecycle } from '../ui/modal-lifecycle.js?v=6.87.12';
import { escapeHtml } from '../core/html.js?v=6.87.12';
import { TelemetryClient } from '../core/telemetry-client.js?v=6.87.12';
import { OutboxSyncClient } from '../core/outbox-sync-client.js?v=6.88.2';
import { SessionSupervisor } from '../core/session-supervisor.js?v=6.88.0';
import { classifyClientError } from '../core/error-policy.js?v=6.87.13';
import { userAvatar } from '../ui/presentation.js?v=6.87.16';
import { DashboardApi } from '../dashboard/dashboard-api.js?v=6.91.2';
import { buildDashboardSeaVessels, hideDashboardOcean, renderOceanVessels } from '../dashboard/dashboard-ocean-animation.js?v=6.88.96';
import { MaintenanceBanner } from '../core/maintenance-client.js?v=6.88.98';

const MODULE_VERSION = '6.92.20';
const THEME_STORAGE_KEY = 'shipsops.theme';
function versioned(path) { return `${path}?v=${MODULE_VERSION}`; }

const NAVIGATION_ICONS = Object.freeze({
  dashboard: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 13h6V4H4v9Zm0 7h6v-5H4v5Zm10 0h6v-9h-6v9Zm0-16v5h6V4h-6Z"/></svg>',
  agents: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm8 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM2 21v-3a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5v3m0-7h2a5 5 0 0 1 5 5v2"/></svg>',
  fleet: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 15h18l-2 4H6l-3-4Zm4-2V7h4V3h2v4h4v6H7Zm-2 8h14"/></svg>',
  instructions: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h10v4H7V3Zm-2 4h14v14H5V7Zm4 4h6m-6 4h6"/></svg>',
  charterers: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm8 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM2 21v-3a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5v3m0-7h2a5 5 0 0 1 5 5v2"/></svg>',
  disp_mech: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10.3 4.3c.4-1.7 2.9-1.7 3.4 0a1.7 1.7 0 0 0 2.6 1.1c1.5-.9 3.3.8 2.4 2.4a1.7 1.7 0 0 0 1.1 2.6c1.7.4 1.7 2.9 0 3.4a1.7 1.7 0 0 0-1.1 2.6c.9 1.5-.8 3.3-2.4 2.4a1.7 1.7 0 0 0-2.6 1.1c-.4 1.7-2.9 1.7-3.4 0a1.7 1.7 0 0 0-2.6-1.1c-1.5.9-3.3-.8-2.4-2.4a1.7 1.7 0 0 0-1.1-2.6c-1.7-.4-1.7-2.9 0-3.4a1.7 1.7 0 0 0 1.1-2.6c-.9-1.5.8-3.3 2.4-2.4 1 .6 2.3.1 2.6-1.1Z"/><circle cx="12" cy="12" r="3"/></svg>',
  requests: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v14H4V5Zm0 2 8 6 8-6"/></svg>',
  users: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm6 10v-3a5 5 0 0 0-5-5H8a5 5 0 0 0-5 5v3m14-8v8m-4-4h8"/></svg>',
  notifications: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9a6 6 0 0 1 12 0c0 7 3 7 3 7H3s3 0 3-7Zm4 11h4"/></svg>',
  health: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12h4l2-5 4 10 2-5h6M12 22C7 19 3 15 3 9a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 6-4 10-9 13Z"/></svg>',
  information: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0-11v6m0-10h.01"/></svg>',
});

function navigationIcon(page) {
  return NAVIGATION_ICONS[page] || NAVIGATION_ICONS.information;
}

function brandIcon() {
  return '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 4v27m-9-17h18M11 31c2 7 7 11 13 13 6-2 11-6 13-13-4 3-8 4-13 4s-9-1-13-4Z"/><circle cx="24" cy="9" r="4"/></svg>';
}

function safeStoredTheme() {
  try {
    const stored = globalThis.localStorage?.getItem(THEME_STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch (_) {
    // Storage is optional. The system preference remains authoritative.
  }
  return globalThis.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

class ShipsOpsApplication {
  constructor(root) {
    this.root = root;
    this.user = null;
    this.permissions = new Permissions();
    this.registry = new ScreenRegistry();
    this.viewState = new ViewStateStore();
    this.current = { route: null, owner: null };
    this.navigationSequence = 0;
    this.navigationInFlight = false;
    this.pendingRouteOpen = false;
    this.screenStates = new ScreenStateStore();
    this.notice = null;
    this.screenRoot = null;
    this.login = null;
    this.passwordChange = null;
    this.notifications = null;
    this.profile = null;
    this.modalLifecycle = null;
    this.clientErrorTelemetryLast = new Map();
    this.authenticationLostTimer = null;
    this.theme = safeStoredTheme();
    this.oceanApi = null;
    this.oceanRefreshTimer = null;
    this.oceanAbort = null;
    this.maintenance = null;
    this.applyTheme();
    this.telemetry = new TelemetryClient({ endpoint: 'api.php', csrfToken: () => this.api?.csrfToken || '' });
    this.telemetry.install();
    this.api = new ApiClient({
      endpoint: 'api.php',
      onAuthenticationLost: error => this.handleAuthenticationLost(error),
      onRequestComplete: result => this.telemetry.apiResult(result),
    });
    this.sync = new OutboxSyncClient({
      api: this.api,
      onEvents: events => this.handleSync(events),
      onError: error => this.showError(error),
      onStatusChange: status => this.handleSyncStatusChange(status),
    });
    this.syncStatus = 'connecting';
    this.boundOnline = () => this.updateOfflineIndicator();
    this.boundOffline = () => this.updateOfflineIndicator();
    this.sessionSupervisor = new SessionSupervisor({
      api: this.api,
      telemetry: this.telemetry,
      onAuthenticated: session => this.refreshAuthenticatedSession(session),
      onAuthenticationLost: error => this.handleAuthenticationLost(error),
      onError: error => this.showError(error),
    });
    this.boundHash = () => this.openCurrentRoute();
    this.boundClick = event => this.shellClick(event);
  }

  applyTheme() {
    document.documentElement.dataset.theme = this.theme;
    const color = this.theme === 'dark' ? '#081a2a' : '#0f3b5e';
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', color);
  }

  toggleTheme() {
    this.theme = this.theme === 'dark' ? 'light' : 'dark';
    this.applyTheme();
    try {
      globalThis.localStorage?.setItem(THEME_STORAGE_KEY, this.theme);
    } catch (_) {
      // Theme persistence is optional.
    }
    const button = this.root.querySelector('[data-app-action="theme"]');
    if (button) {
      button.setAttribute('aria-label', this.theme === 'dark' ? 'Включить светлую тему' : 'Включить тёмную тему');
      button.setAttribute('title', this.theme === 'dark' ? 'Светлая тема' : 'Тёмная тема');
      button.querySelector('[data-theme-symbol]')?.replaceChildren(document.createTextNode(this.theme === 'dark' ? '☀' : '☾'));
    }
  }

  async start() {
    globalThis.addEventListener('hashchange', this.boundHash);
    globalThis.addEventListener('online', this.boundOnline);
    globalThis.addEventListener('offline', this.boundOffline);
    this.root.addEventListener('click', this.boundClick);
    this.startMaintenanceBanner();
    try {
      const session = await this.api.call('auth.session.get', {});
      this.maintenance?.setStatus?.(session?.maintenance || null);
      if (session.authenticated) {
        this.api.setCsrfToken(session.csrf_token);
        await this.authenticate(session.user, session.session_policy || null);
      } else {
        this.showLogin();
      }
    } catch (error) {
      this.showLogin();
      this.showError(error);
    }
  }

  async authenticate(user, sessionPolicy = null) {
    this.login?.destroy();
    this.login = null;
    this.passwordChange?.destroy();
    this.passwordChange = null;
    this.user = user;
    this.permissions.update(user);
    if (user?.must_change_password) {
      await this.showPasswordChange(user);
      return;
    }
    this.telemetry.setEnabled(true);
    this.sessionSupervisor.start(sessionPolicy);
    this.renderShell();
    this.maintenance?.render?.();
    this.updateOfflineIndicator();
    this.startGlobalOcean();
    void this.preloadHeaderProfile();
    void this.primeNotifications();
    await this.registerScreens();
    await this.openCurrentRoute();
    this.sync.start();
  }

  async showPasswordChange(user) {
    this.sessionSupervisor?.stop();
    this.sync?.stop();
    this.telemetry.setEnabled(false);
    this.stopGlobalOcean();
    this.maintenance?.render?.();
    if (this.authenticationLostTimer !== null) { globalThis.clearTimeout(this.authenticationLostTimer); this.authenticationLostTimer = null; }
    this.registry.destroyAll();
    this.notice?.destroy();
    this.notice = null;
    this.root.innerHTML = '';
    const [{ AccessApi }, { PasswordChangeController }] = await Promise.all([
      import(versioned('../access/access-api.js')),
      import(versioned('../auth/password-change-controller.js')),
    ]);
    const accessApi = new AccessApi(this.api);
    this.passwordChange = new PasswordChangeController({
      root: this.root,
      api: accessApi,
      user,
      onComplete: updated => this.authenticate(updated),
      onError: error => console.error(error),
    });
    this.passwordChange.mount();
  }

  showLogin(message = '') {
    this.sessionSupervisor?.stop();
    this.sync?.stop();
    if (this.authenticationLostTimer !== null) { globalThis.clearTimeout(this.authenticationLostTimer); this.authenticationLostTimer = null; }
    this.telemetry.setEnabled(false);
    this.stopGlobalOcean();
    this.navigationSequence += 1;
    this.registry.destroyAll();
    this.current = { route: null, owner: null };
    this.user = null;
    this.permissions.update(null);
    this.maintenance?.render?.();
    this.api.setCsrfToken('');
    this.notice?.destroy();
    this.notice = null;
    this.notifications?.destroy();
    this.notifications = null;
    this.profile?.destroy();
    this.profile = null;
    this.modalLifecycle?.destroy();
    this.modalLifecycle = null;
    this.login?.destroy();
    this.login = null;
    this.root.innerHTML = '';
    this.passwordChange?.destroy();
    this.passwordChange = null;
    const stored = String(message || sessionStorage.getItem('shipsops.login-message') || sessionStorage.getItem('shipsops.rc5.login-message') || '');
    sessionStorage.removeItem('shipsops.login-message');
    sessionStorage.removeItem('shipsops.rc5.login-message');
    this.login = new LoginController({
      root: this.root,
      api: this.api,
      onAuthenticated: response => {
        this.maintenance?.setStatus?.(response?.maintenance || null);
        return this.authenticate(response?.user || response, response?.session_policy || null);
      },
      onError: error => this.showError(error),
      initialMessage: stored,
    });
    this.login.mount();
  }


  handleAuthenticationLost(error) {
    const message = String(error?.message || 'Сессия завершена. Войдите снова.');
    if (this.authenticationLostTimer !== null) return;
    this.authenticationLostTimer = globalThis.setTimeout(() => {
      this.authenticationLostTimer = null;
      this.resetToLogin(message);
    }, 0);
  }

  resetToLogin(message) {
    this.showLogin(String(message || 'Сессия завершена. Войдите снова.'));
  }

  refreshAuthenticatedSession(session) {
    if (!session?.authenticated) return;
    if (session.csrf_token) this.api.setCsrfToken(session.csrf_token);
    if (session.user && this.user) {
      this.user = { ...this.user, ...session.user };
      this.permissions.update(this.user);
    }
  }

  renderShell() {
    const mainNav = MAIN_NAVIGATION.filter(item => canAccessNavigationItem(item, this.permissions));
    const utilityNav = UTILITY_NAVIGATION.filter(item => canAccessNavigationItem(item, this.permissions));
    const accountNav = ACCOUNT_NAVIGATION.filter(item => canAccessNavigationItem(item, this.permissions));
    const themeLabel = this.theme === 'dark' ? 'Включить светлую тему' : 'Включить тёмную тему';
    const firstNavigation = [...mainNav, ...utilityNav, ...accountNav][0]?.target || 'no-access';
    const navLink = (item, className = '') => `<a href="#${escapeHtml(item.target)}" class="${escapeHtml(className)}" data-nav-page="${escapeHtml(item.id)}"${item.iconOnly ? ` aria-label="${escapeHtml(item.label)}" title="${escapeHtml(item.label)}"` : ''}><span class="rc5-nav-icon">${navigationIcon(item.id)}</span>${item.iconOnly ? '<span class="rc5-visually-hidden">' : '<span>'}${escapeHtml(item.label)}</span></a>`;
    this.root.innerHTML = `<div class="rc5-shell">
      <header class="rc5-topbar">
        <div class="rc5-topbar__inner">
          <a href="#${escapeHtml(firstNavigation)}" class="rc5-brand" aria-label="FleetOps CRM — открыть первый доступный раздел">
            <span class="rc5-brand__mark">${brandIcon()}</span>
            <span class="rc5-brand__text"><strong>FleetOps</strong><small>CRM</small></span>
          </a>
          <button class="rc5-nav-toggle" type="button" data-app-action="menu" aria-controls="rc5-primary-navigation" aria-expanded="false">
            <span aria-hidden="true">☰</span><span class="rc5-visually-hidden">Открыть навигацию</span>
          </button>
          <nav id="rc5-primary-navigation" class="rc5-primary-navigation" aria-label="Основная навигация">
            ${mainNav.map(item => navLink(item)).join('')}
          </nav>
          <div class="rc5-user">
            <nav class="rc5-utility-navigation" aria-label="Служебные разделы">
              <span data-sync-status aria-hidden="true" title="Синхронизация: подключение…" class="rc5-topbar-status-icon"><span data-sync-status-dot class="rc5-sync-status-dot"></span></span>
              <span data-offline-status hidden aria-hidden="true" title="Нет подключения к интернету" class="rc5-topbar-status-icon rc5-topbar-status-icon--offline">⚠</span>
              <button type="button" class="rc5-utility-link rc5-notification-trigger" data-app-action="notifications" aria-label="Уведомления" title="Уведомления"><span class="rc5-nav-icon">${navigationIcon('notifications')}</span><span class="rc5-notification-badge" data-unread-badge hidden>0</span></button>
              ${utilityNav.map(item => navLink(item, 'rc5-utility-link')).join('')}
            </nav>
            <button class="rc5-icon-button" type="button" data-app-action="theme" aria-label="${themeLabel}" title="${themeLabel}"><span data-theme-symbol aria-hidden="true">${this.theme === 'dark' ? '☀' : '☾'}</span></button>
            <div class="rc5-account">
              <button class="rc5-account__toggle" type="button" data-app-action="account" aria-controls="rc5-account-menu" aria-expanded="false">
                ${userAvatar({ login: this.user?.login || '?' })}
                <span class="rc5-user__text"><strong>${escapeHtml(this.user?.login || '')}</strong><small>${escapeHtml(this.user?.role || 'user')}</small></span>
                <span class="rc5-account__chevron" aria-hidden="true">⌄</span>
              </button>
              <div id="rc5-account-menu" class="rc5-account__menu" hidden>
                <button type="button" class="rc5-account__link" data-app-action="profile"><span class="rc5-nav-icon">${navigationIcon('users')}</span><span>Мой профиль</span></button>
                ${accountNav.map(item => navLink(item, 'rc5-account__link')).join('')}
                <button type="button" class="rc5-account__logout" data-app-action="logout"><span aria-hidden="true">↪</span><span>Выйти</span></button>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="rc5-workspace">
        <div class="rc5-ocean-decoration" data-ocean-animation aria-hidden="true" hidden></div>
        <div class="rc5-notice-host" data-notice-center aria-live="polite" aria-atomic="true"></div>
        <main id="rc5-main" class="rc5-screen" data-screen-root tabindex="-1"></main>
      </div>
      <div data-notifications-modal-host></div>
      <div data-profile-modal-host></div>
    </div>`;
    this.notice = new NoticeCenter(this.root.querySelector('[data-notice-center]'));
    this.screenRoot = this.root.querySelector('[data-screen-root]');
    this.modalLifecycle = new ModalLifecycle(this.root);
    this.modalLifecycle.start();
  }

  async registerScreens() {
    this.registry.destroyAll();
    this.registry = new ScreenRegistry();
    const onError = error => this.showError(error);
    const onNotice = message => this.notice.show(message);
    const navigate = route => this.navigate(route);

    this.registry.register('no-access', async () => {
      const { NoAccessController } = await import(versioned('../core/no-access-controller.js'));
      return new NoAccessController({ user: this.user });
    });
    this.registry.register('dashboard', async () => {
      const [{ DashboardApi }, { DashboardController }] = await Promise.all([
        import(versioned('../dashboard/dashboard-api.js')),
        import(versioned('../dashboard/dashboard-controller.js')),
      ]);
      return new DashboardController({ api: new DashboardApi(this.api), navigate, onError, permissions: this.permissions, stateStore: this.screenStates.scope('dashboard') });
    });
    this.registry.register('fleet', async () => {
      const [{ FleetApi }, { FleetController }] = await Promise.all([
        import(versioned('../fleet/fleet-api.js')),
        import(versioned('../fleet/fleet-controller.js')),
      ]);
      return new FleetController({ api: new FleetApi(this.api), navigate, onError, onNotice, permissions: this.permissions, stateStore: this.screenStates.scope('fleet.vessels') });
    });
    this.registry.register('instructions', async () => {
      const [{ InstructionsApi }, { InstructionsController }] = await Promise.all([
        import(versioned('../instructions/instructions-api.js')),
        import(versioned('../instructions/instructions-controller.js')),
      ]);
      return new InstructionsController({ api: new InstructionsApi(this.api), navigate, onError, onNotice, permissions: this.permissions, stateStore: this.screenStates.scope('instructions') });
    });
    this.registry.register('charterers', async () => {
      const [{ ReferenceApi }, { CharterersController }] = await Promise.all([
        import(versioned('../reference/reference-api.js')),
        import(versioned('../charterers/charterers-controller.js')),
      ]);
      return new CharterersController({ api: new ReferenceApi(this.api), permissions: this.permissions, onError, onNotice, stateStore: this.screenStates.scope('charterers') });
    });
    this.registry.register('disp_mech', async () => {
      const [{ DispMechApi }, { DispMechController }] = await Promise.all([
        import(versioned('../dispmech/dispmech-api.js')),
        import(versioned('../dispmech/dispmech-controller.js')),
      ]);
      return new DispMechController({ api: new DispMechApi(this.api), onError, onNotice, permissions: this.permissions, stateStore: this.screenStates.scope('disp-mech') });
    });
    this.registry.register('agents', async () => {
      const [{ ReferenceApi }, { AgentsInformationController }] = await Promise.all([
        import(versioned('../reference/reference-api.js')),
        import(versioned('../information/agents-information-controller.js')),
      ]);
      return new AgentsInformationController({ api: new ReferenceApi(this.api), permissions: this.permissions, onError, onNotice, stateStore: this.screenStates.scope('information.agents') });
    });
    this.registry.register('information', async () => {
      const [referenceModule, cargoModule, lookupModule, transferApiModule, transferModule, infoModule] = await Promise.all([
        import(versioned('../reference/reference-api.js')),
        import(versioned('../information/cargos-information-controller.js')),
        import(versioned('../information/lookups-information-controller.js')),
        import(versioned('../transfer/transfer-api.js')),
        import(versioned('../transfer/transfer-controller.js')),
        import(versioned('../information/information-controller.js')),
      ]);
      const referenceApi = new referenceModule.ReferenceApi(this.api);
      const cargos = new cargoModule.CargosInformationController({ api: referenceApi, permissions: this.permissions, onError, onNotice, stateStore: this.screenStates.scope('information.cargos') });
      const lookups = new lookupModule.LookupsInformationController({ api: referenceApi, permissions: this.permissions, onError, onNotice, stateStore: this.screenStates.scope('information.lookups') });
      const transfer = new transferModule.TransferController({ api: new transferApiModule.TransferApi(this.api), permissions: this.permissions, onError, onNotice });
      return new infoModule.InformationController({ permissions: this.permissions, controllers: { cargos, lookups, transfer } });
    });
    this.registry.register('users', async () => {
      const [{ AccessApi }, { UsersController }] = await Promise.all([
        import(versioned('../access/access-api.js')),
        import(versioned('../users/users-controller.js')),
      ]);
      return new UsersController({ api: new AccessApi(this.api), permissions: this.permissions, onError, onNotice, stateStore: this.screenStates.scope('users') });
    });
    this.registry.register('requests', async () => {
      const [{ AccessApi }, { RequestsController }] = await Promise.all([
        import(versioned('../access/access-api.js')),
        import(versioned('../requests/requests-controller.js')),
      ]);
      return new RequestsController({ api: new AccessApi(this.api), permissions: this.permissions, onError, onNotice, stateStore: this.screenStates.scope('requests') });
    });
    this.registry.register('health', async () => {
      const [{ HealthApi }, { HealthController }] = await Promise.all([
        import(versioned('../health/health-api.js')),
        import(versioned('../health/health-controller.js')),
      ]);
      return new HealthController({ api: new HealthApi(this.api), permissions: this.permissions, onError, onNotice });
    });
  }

  startGlobalOcean() {
    this.stopGlobalOcean({ keepMarkup: true });
    this.oceanApi = new DashboardApi(this.api);
    void this.refreshGlobalOcean();
    this.oceanRefreshTimer = globalThis.setInterval(() => {
      void this.refreshGlobalOcean();
    }, 60000);
  }

  stopGlobalOcean({ keepMarkup = false } = {}) {
    if (this.oceanRefreshTimer !== null) {
      globalThis.clearInterval(this.oceanRefreshTimer);
      this.oceanRefreshTimer = null;
    }
    this.oceanAbort?.abort?.();
    this.oceanAbort = null;
    this.oceanApi = null;
    if (!keepMarkup) hideDashboardOcean();
  }


  maintenanceHost() {
    let host = document.querySelector('[data-maintenance-host-global]');
    if (!host) {
      host = document.createElement('div');
      host.setAttribute('data-maintenance-host-global', '');
      document.body.appendChild(host);
    }
    return host;
  }

  startMaintenanceBanner() {
    if (this.maintenance) return;
    this.maintenance = new MaintenanceBanner({
      api: this.api,
      onError: error => this.showError(error),
      isDeveloper: () => String(this.user?.role || '').toLowerCase() === 'dev',
      isAuthenticated: () => !!this.user,
    });
    this.maintenance.mount(this.maintenanceHost());
    this.maintenance.start();
  }

  stopMaintenanceBanner() {
    this.maintenance?.destroy?.();
    this.maintenance = null;
  }

  async refreshGlobalOcean() {
    if (!this.user || !this.oceanApi) return;
    this.oceanAbort?.abort?.();
    const abort = new AbortController();
    this.oceanAbort = abort;
    try {
      const data = await this.oceanApi.overview('', 1, abort.signal);
      if (abort.signal.aborted || !this.user) return;
      renderOceanVessels(buildDashboardSeaVessels(data || {}));
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.warn('Dashboard ocean refresh failed', error);
      renderOceanVessels([]);
    } finally {
      if (this.oceanAbort === abort) this.oceanAbort = null;
    }
  }

  async ensureNotifications() {
    if (this.notifications) return this.notifications;
    const [{ AccessApi }, { NotificationsController }] = await Promise.all([
      import(versioned('../access/access-api.js')),
      import(versioned('../notifications/notifications-controller.js')),
    ]);
    const onError = error => this.showError(error);
    const onNotice = message => this.notice?.show(message);
    this.notifications = new NotificationsController({ api: new AccessApi(this.api), permissions: this.permissions, onError, onNotice, stateStore: this.screenStates.scope('notifications'), onUnreadChange: count => this.updateUnreadCount(count) });
    this.notifications.mount(this.root.querySelector('[data-notifications-modal-host]'));
    return this.notifications;
  }

  async primeNotifications() {
    try {
      const notifications = await this.ensureNotifications();
      await notifications?.preload();
    } catch (error) {
      console.warn('Notification badge preload failed', error);
    }
  }

  async preloadHeaderProfile() {
    if (!this.user) return;
    try {
      const { AccessApi } = await import(versioned('../access/access-api.js'));
      if (!this.user) return;
      const accessApi = new AccessApi(this.api);
      const data = await accessApi.getOwnProfile();
      if (!this.user) return;
      const profile = data.profile || {};
      this.profile?.prime(profile);
      this.applyProfile(profile);
    } catch (error) {
      console.warn('Profile header preload failed', error);
    }
  }

  async ensureProfile() {
    if (this.profile) return this.profile;
    const [{ AccessApi }, { ProfileController }] = await Promise.all([
      import(versioned('../access/access-api.js')),
      import(versioned('../profile/profile-controller.js')),
    ]);
    const accessApi = new AccessApi(this.api);
    this.profile = new ProfileController({ api: accessApi, onError: error => this.showError(error), onNotice: message => this.notice?.show(message), onUpdated: profile => this.applyProfile(profile) });
    this.profile.mount(this.root.querySelector('[data-profile-modal-host]'));
    void this.preloadHeaderProfile();
    return this.profile;
  }

  accessiblePages() {
    return ROUTE_NAVIGATION.filter(item => canAccessNavigationItem(item, this.permissions)).map(item => item.id);
  }

  normalizeRoute(route) {
    const redirected = resolveNavigationTarget(route.page, route.section);
    const pages = this.accessiblePages();
    const page = pages.includes(redirected.page) ? redirected.page : (pages[0] || 'no-access');
    const requestedReturnTo = String(route.returnTo || '');
    const returnTo = requestedReturnTo && requestedReturnTo !== page && pages.includes(requestedReturnTo) ? requestedReturnTo : '';
    return { page, section: redirected.section || route.section || '', recordId: route.recordId, returnTo };
  }

  navigate(route, { replace = false } = {}) {
    const hash = formatRoute(this.normalizeRoute(route));
    if (replace) globalThis.history.replaceState(null, '', hash);
    else globalThis.location.hash = hash;
  }

  async openCurrentRoute() {
    if (this.navigationInFlight) {
      this.pendingRouteOpen = true;
      return;
    }
    this.navigationInFlight = true;
    try {
      do {
        this.pendingRouteOpen = false;
        await this.performRouteOpen();
      } while (this.pendingRouteOpen);
    } finally {
      this.navigationInFlight = false;
    }
  }

  async performRouteOpen() {
    if (!this.user || !this.screenRoot) return;
    const sequence = ++this.navigationSequence;
    const requested = parseRoute();
    const route = this.normalizeRoute(requested);
    const canonical = formatRoute(route);
    if (globalThis.location.hash !== canonical) globalThis.history.replaceState(null, '', canonical);
    if (this.current.route) this.viewState.capture(this.current.route, this.screenRoot);
    const previousOwner = this.current.owner;
    previousOwner?.deactivate?.();
    previousOwner?.unmount?.();
    if (sequence !== this.navigationSequence) return;
    this.screenRoot.textContent = '';
    const owner = await this.registry.get(route.page);
    this.telemetry.navigation(route);
    owner.mount(this.screenRoot);
    this.current = { route, owner };
    this.markNavigation(route);
    try {
      await owner.activate(route);
      if (sequence !== this.navigationSequence || this.current.owner !== owner) return;
      requestAnimationFrame(() => {
        if (sequence === this.navigationSequence) this.viewState.restore(route, this.screenRoot);
      });
    } catch (error) {
      if (sequence === this.navigationSequence) this.showError(error);
    }
  }

  async handleSync(events) {
    if (!Array.isArray(events) || !events.length) return;
    const ownProfileChanged = events.some(event => String(event?.aggregate_type || '') === 'user_profile' && Number(event?.payload?.user_id || 0) === Number(this.user?.id || 0));
    if (events.some(event => String(event?.aggregate_type || '') === 'notification')) {
      const notifications = await this.ensureNotifications();
      await notifications?.preload();
    }
    const maintenanceChanged = events.some(event => String(event?.aggregate_type || '') === 'maintenance_window');
    if (maintenanceChanged) {
      globalThis.dispatchEvent?.(new CustomEvent('shipsops:maintenance-refresh'));
      void this.maintenance?.refresh?.();
    }
    if (ownProfileChanged) {
      try {
        const [{ AccessApi }] = await Promise.all([import(versioned('../access/access-api.js'))]);
        const accessApi = new AccessApi(this.api);
        const data = await accessApi.getOwnProfile();
        const profile = await this.ensureProfile();
        profile?.prime(data.profile || {});
        this.applyProfile(data.profile || {});
      } catch (error) {
        this.showError(error);
      }
    }
    await this.current.owner?.onSync?.(events);
    void this.refreshGlobalOcean();
  }

  updateUnreadCount(count) {
    const badge = this.root.querySelector('[data-unread-badge]');
    if (!badge) return;
    const value = Math.max(0, Number(count || 0));
    badge.textContent = value > 99 ? '99+' : String(value);
    badge.hidden = value === 0;
  }

  handleSyncStatusChange(status) {
    const wasLive = this.syncStatus === 'live';
    this.syncStatus = status;
    const indicator = this.root?.querySelector('[data-sync-status]');
    const dot = this.root?.querySelector('[data-sync-status-dot]');
    if (indicator && dot) {
      const presentation = {
        live: { variant: 'success', title: 'Синхронизация: реальное время' },
        follower: { variant: 'success', title: 'Синхронизация: реальное время (через другую вкладку)' },
        hidden: { variant: 'muted', title: 'Синхронизация приостановлена (вкладка неактивна)' },
        reconnecting: { variant: 'warning', title: 'Синхронизация: переподключение…' },
        fallback: { variant: 'warning', title: 'Синхронизация: обновление раз в минуту (нет прямого соединения)' },
        connecting: { variant: 'muted', title: 'Синхронизация: подключение…' },
      }[status] || { variant: 'muted', title: 'Синхронизация' };
      dot.className = `rc5-sync-status-dot rc5-sync-status-dot--${presentation.variant}`;
      indicator.title = presentation.title;
    }
    if (wasLive && (status === 'reconnecting' || status === 'fallback')) {
      this.notice?.show('Обновление данных временно замедлилось — переключились на резервный режим синхронизации.', 'warning');
    }
  }

  updateOfflineIndicator() {
    const indicator = this.root?.querySelector('[data-offline-status]');
    if (!indicator) return;
    indicator.hidden = globalThis.navigator?.onLine !== false;
  }

  applyProfile(profile) {
    if (!profile) return;
    const label = String(profile.login || this.user?.login || '').trim();
    const avatar = this.root.querySelector('.rc5-user__avatar');
    const image = String(profile.photo_data_url || '').trim();
    if (avatar) avatar.outerHTML = userAvatar({ login: label, image });
    const name = this.root.querySelector('.rc5-user__text strong');
    if (name) name.textContent = label || String(this.user?.login || '');
  }

  markNavigation(route) {
    const page = String(route?.page || 'dashboard');
    const section = String(route?.section || '');
    const active = page;
    this.screenRoot?.setAttribute('data-page', page);
    this.screenRoot?.setAttribute('data-section', section);
    for (const link of this.root.querySelectorAll('[data-nav-page]')) {
      if (link.dataset.navPage === active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    }
  }

  setMenuOpen(open) {
    const nav = this.root.querySelector('#rc5-primary-navigation');
    const button = this.root.querySelector('[data-app-action="menu"]');
    if (!nav || !button) return;
    nav.classList.toggle('is-open', Boolean(open));
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  setAccountOpen(open) {
    const menu = this.root.querySelector('#rc5-account-menu');
    const button = this.root.querySelector('[data-app-action="account"]');
    if (!menu || !button) return;
    menu.hidden = !open;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  async shellClick(event) {
    const navLink = event.target.closest('[data-nav-page]');
    if (navLink) {
      this.setMenuOpen(false);
      this.setAccountOpen(false);
    }
    const action = event.target.closest('[data-app-action]')?.dataset.appAction;
    if (!action) {
      if (!event.target.closest('.rc5-account')) this.setAccountOpen(false);
      return;
    }
    if (action === 'theme') {
      this.toggleTheme();
      return;
    }
    if (action === 'menu') {
      const expanded = event.target.closest('[data-app-action="menu"]')?.getAttribute('aria-expanded') === 'true';
      this.setMenuOpen(!expanded);
      this.setAccountOpen(false);
      return;
    }
    if (action === 'account') {
      const expanded = event.target.closest('[data-app-action="account"]')?.getAttribute('aria-expanded') === 'true';
      this.setAccountOpen(!expanded);
      this.setMenuOpen(false);
      return;
    }
    if (action === 'notifications') {
      this.setAccountOpen(false);
      const notifications = await this.ensureNotifications();
      await notifications?.open();
      return;
    }
    if (action === 'profile') {
      this.setAccountOpen(false);
      const profile = await this.ensureProfile();
      await profile?.open();
      return;
    }
    if (action !== 'logout') return;
    try {
      await this.api.call('auth.logout', {});
    } catch (error) {
      this.showError(error);
    } finally {
      this.api.setCsrfToken('');
      this.showLogin();
    }
  }

  shouldRecordClientIssue(classified) {
    if (!classified?.eventType) return false;
    if (!classified.silent) return true;
    const key = [
      classified.eventType,
      classified.action || '',
      classified.payload?.code || '',
      classified.payload?.status || '',
    ].join('|');
    const now = Date.now();
    const last = Number(this.clientErrorTelemetryLast.get(key) || 0);
    if (now - last < 60000) return false;
    this.clientErrorTelemetryLast.set(key, now);
    return true;
  }

  showError(error) {
    const classified = classifyClientError(error);
    if (this.shouldRecordClientIssue(classified)) {
      this.telemetry.record(classified.eventType, {
        level: classified.level,
        action: classified.action,
        message: classified.message,
        payload: classified.payload,
      });
    }
    if (classified.silent) return;
    if (this.notice) this.notice.show(classified.message, classified.noticeType);
    else if (classified.level === 'error') console.error(error);
    else console.warn(error);
  }
}

const root = document.querySelector('[data-shipsops-root]');
if (!root) throw new Error('ShipsOps root not found');
new ShipsOpsApplication(root).start();
